<template>
	<div class="my-table roleManagementPage">
		<!-- 面包屑组件 -->
		<div class="searchBox relative">
			<div class="fl">
				<div class="back" @click="returnPage">
					<span class="el-icon-back btn-icon"></span>
					<span>返回</span>
				</div>
				<div @click="goItemPage(item,index)"
					:class="item.path == $route.path?'btnC activedBtn mr2':'btnC addBtn mr2'"
					v-for="(item,index) in settingOption" :key="index">
					<span class="btn-txt">{{item.name}}</span>
				</div>
			</div>
		</div>
		<!-- 面包屑 -->
		<el-card>
			<div class="table-header mb15">
				<div class="left">
					<span>当前位置：系统设置/皮肤管理</span>
				</div>
			</div>
			<el-row :gutter="20">
				<el-col :span="6">
					<div @click="themeType = item.themeType"
						:class="themeType == item.themeType?'themeOption active':'themeOption'"
						v-for="(item,index) in themeOption" :key="index">
						<p>{{item.name}}</p>
					</div>
					<div class="btnC activedBtn mr2 confirmTheme" @click="handleConfirm">
						<span class="btn-txt">确定选择</span>
					</div>
				</el-col>
				<el-col :span="18">
					<div class="treeHeader">
						<span>皮肤效果预览</span>
					</div>
					<img width="100%" :src="themePics[themeType]">
				</el-col>
			</el-row>
		</el-card>
	</div>
</template>

<script>
	import menuMixin from './menuMixin';
	export default {
		mixins: [menuMixin],
		data() {
			return {
				themeType: this.theme || 'white',
				themePic: require('@/assets/picture/icon/white_img.png'), //主题预览图片
				subNavIndex: 4,
				settingOption: [{
						path: '/roleManagement',
						name: '角色管理'
					},
					{
						path: '/menuManagement',
						name: '菜单管理'
					},
					{
						path: '/authManagement',
						name: '权限管理'
					},
					{
						path: '/logManagement',
						name: '日志管理'
					},
					{
						path: '/themeManagement',
						name: '皮肤管理'
					}
				],
                themePics: {
                    white: require('@/assets/picture/icon/white_img.png'),
                    black: require('@/assets/picture/icon/black_img.png'),
                },
				themeOption: [{
						name: '皮肤模式 - 简洁白',
						themeType: 'white'
					},
					{
						name: '皮肤模式 - 星夜黑',
						themeType: 'black'
					}
				], //主题选择
				//用于获取数据列表
				queryInfo: {
					cmptName: '',
					endCreateTm: '',
					pageNum: 1,
					pageSize: 10,
					productTmplCmptId: '',
					projName: '',
					spvTm: '',
					startCreateTm: '',
					submitterName: '',
					witnCde: '',
					witnType: '',
				},
			};
		},
        watch: {
            theme(val) {
                this.themeType = val
            },
        },
        computed: {
            theme() {
                return this.$store.state.theme;
            }
        },
		methods: {
			// 返回上一页
			returnPage() {
				this.$router.go(-1);
			},
			// 跳转系统设置子页
			goItemPage(item, index) {
				this.$router.replace({
					path: item.path
				});
				this.subNavIndex = index;
			},
            handleConfirm() {
                this.$store.commit('TOGGLE_THEME', this.themeType)
            }
		},
	};
</script>

<style lang="less" scoped>
    .theme_black{
        .roleManagementPage{
            .themeOption{
                color: #fff;
                background: #3A434A;
                &.active{
                    background: #191C22;
                }
            }
            .treeHeader{
                border-bottom: 1px solid #3A434A;
                color: #fff;
            }
        }
    }
	.roleManagementPage {
		.back {
			display: inline-block;
			margin-right: 2.6rem;

			img {
				width: 1.8rem;
				height: 1.8rem;
				margin-right: 0.7rem;
			}

			span {
				font-size: 1.6rem;
				font-weight: 400;
				color: #333333;
			}
		}

		.themeOption {
			padding: 3.4rem 0 3.4rem 2.5rem;
			font-size: 1.4rem;
			font-weight: 400;
			color: #333333;
            background: #F8F8F8;
			cursor: pointer;
		}

		.active {
			background: #DAE4F9;
		}

		.confirmTheme {
			margin: 0 auto;
			margin-top: 4rem;
            width: 6em;
            display: block;
		}

		.w32 {

			/deep/ .el-input,
			/deep/ .el-input__inner {
				width: 100% !important;
			}
		}

		.mb15 {
			margin-bottom: 1.5rem;
		}

		.searchBox {
			/*width: 33.6rem !important;*/
			height: 3.2rem;

			.btnC {
				padding: 0.6rem 2.6rem;
			}
		}
		.treeHeader {
			border-bottom: 1px solid #CBCBCB;
			padding: 1.5rem 0;
			font-size: 1.6rem;
			font-weight: 400;
			color: #333333;
			margin-bottom: 1rem;
		}
	}
</style>
